import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
export default class GroupService extends BaseService {
    static async getGroups(params = {}) {
        const res = await this.get(`/groups`, params);
        return unwrapResponse(res);
    }
    static async createGroup(params = {}) {
        const res = await this.post(`/groups`, params);
        return unwrapResponse(res);
    }
    static async getGroup(params = {}) {
        const res = await this.get(`/groups/` + params.groupId, {});
        return unwrapResponse(res);
    }
    static async outGroup(params = {}) {
        const res = await this.post(`/groups/` + params.groupId + `/leave`, {});
        return res;
    }
    static async addMembers(params = {}) {
        const res = await this.post(`/groups/` + params.groupId + `/add-members`, { user_ids: params.members });
        return res;
    }
    static async getFiles(params = {}) {
        const res = await this.get(`/groups/` + params.groupId + `/files`, params);
        return unwrapResponse(res);
    }
    static async getWorkProcess(params = {}) {
        const res = await this.get(`/groups/` + params.groupId + `/work_process`, {});
        return unwrapResponse(res);
    }
    static async updateWallpaper(params) {
        const groupId = params.get("groupId");
        params.delete("groupId");
        const res = await this.post(`/groups/` + String(groupId) + `/wallpaper`, params);
        return unwrapResponse(res);
    }
    static async getMembers(params = {}) {
        const res = await this.get(`/groups/` + params.groupId + `/members`, params);
        return unwrapResponse(res);
    }
    static async pinGroup(params = {}) {
        const res = await this.post(`/groups/` + params.groupId + `/pin`, params);
        return unwrapResponse(res);
    }
    static async requestMember(params = {}) {
        const res = await this.post(`/groups/` + params.groupId + `/request-member`, params);
        return unwrapResponse(res);
    }
    static async updateGroup(groupId, params = {}) {
        const res = await this.post(`/groups/` + groupId, params);
        return unwrapResponse(res);
    }
    static async updateGroupRules(groupId, params = {}) {
        const res = await this.post(`/groups/` + groupId + `/rules`, params);
        return unwrapResponse(res);
    }
    static async approveJoinGroupRequest(groupId, userId, params = {}) {
        const res = await this.post(`/groups/` + groupId + `/accept-member/` + userId, params);
        return unwrapResponse(res);
    }
    static async removeMember(groupId, userId) {
        const res = await this.post(`/groups/` + groupId + `/members/` + userId);
        return unwrapResponse(res);
    }
    static async handleAdminRole(groupId, userId, params = {}) {
        const res = await this.post(`/groups/` + groupId + `/admin/` + userId, params);
        return unwrapResponse(res);
    }
    static async getGroupOverview(params = {}) {
        const res = await this.get(`/groups/overview`, params);
        return unwrapResponse(res);
    }
    static async toggleNotification(groupId, params = {}) {
        const res = await this.post(`/groups/` + groupId + `/off-notification`, params);
        return unwrapResponse(res);
    }
    static async createChatSocical(groupId, params = {}) {
        const res = await this.post(`/chat-group/` + groupId, params);
        return unwrapResponse(res);
    }
    static async getLinkMetaDataChatGroup(params) {
        const res = await this.get(`/chat-group/${params.group_id}/get-link-metadata`, params);
        return unwrapResponse(res);
    }
    static async getFileChatGroup(params) {
        const res = await this.get(`/chat-group/${params.group_id}/files`, params);
        return unwrapResponse(res);
    }
    static async updateRoleMemberGroup(group_id, params = {}) {
        const res = await this.post(`/chat-group/${group_id}/join-policy`, params);
        return unwrapResponse(res);
    }
    static async updateAnnouncementPolicy(group_id, params = {}) {
        const res = await this.post(`/chat-group/${group_id}/announcement-policy`, params);
        return unwrapResponse(res);
    }
    static async updateChatRetention(group_id, params = {}) {
        const res = await this.post(`/chat-group/${group_id}/retention`, params);
        return unwrapResponse(res);
    }
    static async updateChatGroupRules(chatGroupId, params = {}) {
        const res = await this.post(`/chat-group/${chatGroupId}/rules`, params);
        return unwrapResponse(res);
    }
    static async getMemberGroupPost(params = {}) {
        const res = await this.get(`/groups/${params.group_id}/mention-members`, params);
        return unwrapResponse(res);
    }
}
